<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-05 16:31:19
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-30 17:56:17
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\tableCells\titleCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="shopScoreCell">
		<shop-score :shopScores="shopScoreData" :open-delay="300" v-if="$isDy(row.platformId)">
			<span class="cursor-pointer yx-color-pure-1 hover" slot="popover">
				<span>{{ row.shopScore | formatEmpty }}</span>
				<i class="el-icon-arrow-right"></i>
			</span>
		</shop-score>
		<div v-if="$isKs(row.platformId)">{{ row.shopScore | formatEmpty }}</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import shopScore from '@/components/shopScore';
export default {
	mixins: [mixin],
	components: {
		shopScore,
	},
	computed: {
		shopScoreData({ row }) {
			return {
				shop_score: row.shopScore,
				shop_score_level: row.shopScoreLevel,
				product_score: row.productScore,
				product_score_level: row.productScoreLevel,
				logistics_score: row.logisticsScore,
				logistics_score_level: row.logisticsScoreLevel,
				service_score: row.serviceScore,
				service_score_level: row.serviceScoreLevel,
			};
		},
	},
	data() {
		return {};
	},
	methods: {},
};
</script>
<style lang="less" scoped></style>
